module.exports = __webpack_public_path__ + "static/media/rna-based-vaccine.f1d632ef.jpg";